module.exports = __webpack_public_path__ + "img/adriaan-van-der-ploeg.7fe8ce09.jpg";